export const NOTIFICATIONS_QUERY_KEY = ["notifications", "unread-counts"] as const;

/** Stale window for the unread-counts query, shared by the query and the navigation refetch guard. */
export const NOTIFICATIONS_STALE_TIME = 60000;
